import React from 'react';
import { COLORS,FONTS } from '@bcm/constants';
import { View, Text, StyleSheet } from 'react-native';
import { Parallax } from 'react-parallax';
import { useSelector } from 'react-redux';

const bgImageLandscape = require('../../assets/images/doctorLandscape.jpg');
const bgImagePortrait = require('../../assets/images/doctorPortrait.jpg');

const Splash = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			height: '90vh',
			width: '100%',
			justifyContent: 'center',
			alignItems: 'flex-end',
		},
		textContainer: {
			width: isLandscape ? '40vw' : '90vw',
			marginRight: '5vw',
			marginLeft: isLandscape ? undefined : '5vw',
			padding: 10,
			borderRadius: 10,
			backgroundColor: COLORS.white,
			opacity: 0.9
		},
		text: {
			fontFamily: FONTS.default,
			fontSize: 30,
		},
	});

	return (
		<>
			<Parallax
				blur={1}
				bgImage={isLandscape ? bgImageLandscape : bgImagePortrait}
				bgImageAlt="Doctor Splash Page"
				strength={ isLandscape ? 400 : 200}
			>
				<View style={styles.container}>
					<View style={styles.textContainer}>
						<Text style={styles.text}>
							BurnCam links Patients and Local Providers to Burn Specialists with AI Augmented Telemedicine
						</Text>
					</View>
				</View>
			</Parallax>
		</>
	);
};

export default Splash;